import { v4 as uuidv4 } from 'uuid'
import {
  FAILURE_MESSAGE_CATEGORIES,
  FAILURE_MESSAGE_DEFAULTS,
} from './constants'
import {
  CustomCheckoutFormValues,
  FailureMessageCategory,
  FailureMessageItem,
  InformationSectionItem,
  PaymentMethodItem,
} from './types'
import { generatePaymentMethodSlug } from './utils'

export { FAILURE_MESSAGE_CATEGORIES, FAILURE_MESSAGE_CATEGORY_LABELS } from './constants'

export const createInformationSection = (): InformationSectionItem => ({
  id: uuidv4(),
  icon: '',
  text: '',
  isNew: true,
})

export const createPaymentMethod = (overrides?: Partial<PaymentMethodItem>): PaymentMethodItem => {
  const item: PaymentMethodItem = {
    id: uuidv4(),
    name: '',
    icon: '',
    slug: '',
    enabled: true,
    isNew: true,
    ...overrides,
  }

  return {
    ...item,
    slug: generatePaymentMethodSlug(item.name),
  }
}

export const createFailureMessage = (
  category: FailureMessageCategory,
  overrides?: Partial<FailureMessageItem>
): FailureMessageItem => ({
  id: uuidv4(),
  category,
  ...FAILURE_MESSAGE_DEFAULTS[category],
  isNew: true,
  ...overrides,
})

export const createDefaultFailureMessages = (): FailureMessageItem[] =>
  FAILURE_MESSAGE_CATEGORIES.map((category) => createFailureMessage(category))

export const defaultCustomCheckoutValues: CustomCheckoutFormValues = {
  bottomSheet: {
    heading: 'Select payment method',
    informationSections: [
      { ...createInformationSection(), text: 'Cancel anytime' },
      { ...createInformationSection(), text: 'No hidden charges' },
    ],
    paymentMethods: [
      createPaymentMethod({ name: 'Google Pay' }),
      createPaymentMethod({ name: 'PhonePe' }),
      createPaymentMethod({ name: 'Paytm' }),
      createPaymentMethod({ name: 'Scan & Pay' }),
    ],
  },
  qrDisplay: {
    heading: 'Scan to pay with any UPI',
    description: 'Use any UPI app to scan and complete your payment.',
    instructionText: 'Point your camera at the QR code to pay',
    shareMessage: 'Share this payment link with someone else',
  },
  loadingPage: {
    heading: "Hold on! We're verifying your payment",
    description: 'Please wait while we confirm your payment.',
    timeLimitSeconds: 60,
  },
  confirmingLoader: {
    heading: 'Confirming your payment',
    description: 'Please do not close the app while we verify your payment.',
  },
  paymentExpired: {
    image: '',
    title: 'Payment session expired',
    description: 'Your payment session has expired. Please try again.',
    ctaText: 'Try again',
  },
  refundInitiated: {
    image: '',
    title: 'Refund initiated',
    description:
      'Your refund has been initiated and will be credited within 5-7 business days.',
    ctaText: 'OK',
  },
  failureMessages: createDefaultFailureMessages(),
  cancelPopup: {
    heading: 'Are you sure you? This will cancel the payment',
    description: 'Your payment has not been completed yet.',
    ctaText1: 'No',
    ctaText2: 'Yes, Cancel',
  },
}
